<section class="wrapper">
  <div class="faef-container">
    <label class="faef-label">Nome</label>
    <span class="mercadoria-info destaque">{{ mercadoria.nomeMercadoria }}</span>

    <div class="horizontal-grid">
      <label class="faef-label">Quantidade vendida</label>
      <span class="mercadoria-info">{{ mercadoria.quantidadeVendida }}</span>

      <label class="faef-label">Custo unitário</label>
      <span class="mercadoria-info">{{ mercadoria.precoUnitarioCompra | currency:'BRL':'symbol':'1.2-2' }}</span>

      <label class="faef-label">Quantidade estoque</label>
      <span class="mercadoria-info">{{ mercadoria.quantidadeEstoque }}</span>

      <label class="faef-label">Preço unitário</label>
      <span class="mercadoria-info">{{ mercadoria.precoUnitarioVenda | currency:'BRL':'symbol':'1.2-2' }}</span>
    </div>
  </div>

  <div class="actions">
    <a (click)="edit.emit(mercadoria)">alterar</a> <a (click)="remove.emit(mercadoria)">remover</a>
  </div>
</section>
